import React, {useEffect, useState} from "react";
import Config from "../Config";
import token from "../AuthToken";
import _ from "../Trans";
import ReactGA from "react-ga4";
import {Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";

export default function News() {
    const [news, setNews] = useState([]);

    useEffect(() => fetchNews(setNews), []);

    useEffect(() => sendPageView("/news/", _('News')), []);

    return (
        <Container style={{'marginBottom': '50px'}}>
            {news.map(news => <NewsEntry key={news?.created_at} image={news?.image} title={news?.title} body={news?.body}/>)}
        </Container>
    )
}

const fetchNews = function (setNews) {
    fetch(Config.newsUrl, {
        headers: {
            Authorization: 'Token ' + token,
            'Content-Type': 'application/json'
        }
    })
    .then((e) => {
        if (e.status < 300) {
            return Promise.resolve(e.json())
        }
        return Promise.reject(e)
    })
    .then(e => setNews(e.results))
}

const sendPageView = function(page, title) {
    ReactGA.initialize(Config.GA_CODE);
    ReactGA.send({hitType: "pageview", page: page, title: title});
}

function NewsEntry({image, title, body}) {
    image = image.replace("Gremory/", "");
    return(
        <div>
            <Row className="text-left">
                <Col className="col-lg-2 d-none d-lg-block"/>
                <Col lg={8} md={12} sm={12} xs={12}>
                    <Card>
                        <CardHeader className="font-weight-bold" expand="true"
                            style={{backgroundColor:'#081d40'}}
                           /* style={{color: 'black',
                                background: 'url(https://asobal.es/image.php?image=/imagenes/noticiascap/30.jpg) bottom right 15% no-repeat #46B6AC'
                            }}*/>
                            <Row className="text-left">
                                <Col xs={ image !== "" ? 3: 0} style={{
                                    background: 'url(https://cope-cdnmed.cope.es/resources/jpg/7/2/1507710813427.jpg)'
                                }}>
                                    {Config.appCustomer === 'asobal' &&
                                    <img src="https://fantasy.asobal.es/static/images/news/logoplenitude.png" className="img-fluid img-adaptation" alt="Logo"/>
                                    }
                                    {Config.appCustomer !== 'asobal' &&
                                    <img src={image} className="img-fluid img-adaptation" alt="Logo"/>
                                    }
                                </Col>
                                <Col xs={ image !== "" ? 9: 12} style={{color:'#fff'}} className="d-flex align-self-center">
                                     {title}
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row className="text-left">
                                <Col xs={12} className="mt-3">
                                     <p dangerouslySetInnerHTML={{__html: body}} style={{color: 'black'}}></p>
                                </Col>
                            </Row>
                        </CardBody>
                     </Card>
                </Col>
            </Row>
        </div>
    )
}